exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"LinkButtons2.l.scss","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/LinkButtons2/LinkButtons2.l.scss
// module id = 1009
// module chunks = 117